import { atom } from 'jotai';
import { DEFAULT_PAGINATION } from '@/common/pagination/types.ts';

export const workOrderPaginationAtom = atom(DEFAULT_PAGINATION);

export const resetWorkOrderPaginationOnFilterChangeAtom = atom(null, (_get, set) => {
  set(workOrderPaginationAtom, DEFAULT_PAGINATION);
});
